/**
 * Created by david on 2017/2/15.
 */

const handleError = {}

//捕捉Ajax错误信息
handleError.ajaxError = (error)=>{
    if (error && error.response) {
        // 请求出错了. 显示服务器返回的错误
        if (error.response.status >= 400 && error.response.data.message) {
            error.message = error.response.data.message;
       }
    }
    //重新抛出错误;
    throw error;
}

export default handleError;



// WEBPACK FOOTER //
// ./src/helpers/handleError.js